package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_01_04_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes eat a large breakfast of oatmeal and water conjured by Falorn, scorpion meat harvested by Bigglesworth and Annette, and prickly pears gathered by Caper. The heroes continue their journey through the desert, and the day passes uneventfully.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During the 1st watch of the night, Falorn and Bigglesworth notice that 100 feet south of their campsite, there is a small shrine consisting of rudimentary alter carved into the rock. The shelf is about 4 feet high and has a few old bowls and unlit candles burned down to the wicks. They believe that this shrine might be to the Neutral God of Weather, Toramokan. During Dirk’s watch, he sees movement near the shrine. During Tuesday and Caper’s watch, Tuesday flies up into the air and thinks he also sees someone near the shrine. The heroes all suspect this movement is the Lalia, a Erinyes devil who has taken an interest in the heroes supposedly because her people also oppose demonic forces.")
    }
}
